import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ApiService } from 'src/app/services/api.service';
import { Device, DeviceType, VISITOR_ID } from 'src/app/models/device';
import { LocaleService } from 'src/app/services/locale.service';
import { ConfigService } from 'src/app/services/config.service';
import { Router } from '@angular/router';
import { CustomerType } from '../../../models/client-configuration';
import { ToastService } from '../../../_core/services/toast.service';

const MAX_ACTIVE_DEVICES = 6;
const MAX_ACTIVE_DEVICES_GACETA = 3;

@Component({
  selector: 'app-user-active-devices',
  templateUrl: './user-active-devices.component.html',
  styleUrls: ['./user-active-devices.component.scss'],
})
export class UserActiveDevicesComponent implements OnInit {
  private readonly toastService = inject(ToastService);

  section = 'devices';
  activeDevices: Device[] = [];
  currentDeviceId: string;
  devicesLeft: number;
  hints: Map<string, string> = new Map();
  devicesDescription: string;
  customerType: CustomerType;

  constructor(
    private router: Router,
    private configService: ConfigService,
    private authService: AuthService,
    private apiService: ApiService,
    private localeService: LocaleService
  ) {
    this.currentDeviceId = localStorage.getItem(VISITOR_ID);

    this.apiService.getUserActiveDevices(this.authService.getLoggedUser().id).subscribe((devices) => {
      this.activeDevices = devices
        .filter((device) => device.active)
        .sort((a, b) => (a.modificationDate < b.modificationDate ? 1 : -1))
        .map((device) => {
          device.type = this.resolveDeviceType(device.deviceName);
          this.hints.set(
            device.deviceId,
            device.deviceId === this.currentDeviceId ? 'button.devices.unableToActivate' : 'button.devices.deactivate'
          );
          return device;
        });

      this.devicesLeft = this.configService.isGacetaJuridica()
        ? MAX_ACTIVE_DEVICES_GACETA - this.activeDevices.length
        : MAX_ACTIVE_DEVICES - this.activeDevices.length;
    });
  }

  ngOnInit() {
    this.devicesDescription = this.localeService.instant('user.devices.description', {
      devices: this.configService.isGacetaJuridica() ? MAX_ACTIVE_DEVICES_GACETA : MAX_ACTIVE_DEVICES,
    });
    if (!this.configService.get().showDeviceManagement) {
      this.router.navigate(['/user/checkouts']);
    }
    this.customerType = this.configService.customerType;
  }

  deactivate(device: Device) {
    this.apiService.deactivateDevice(device).subscribe((_device) => {
      this.toastService.showToast('messages.devices.disabled');
      setTimeout(() => window.location.reload(), 100);
    });
  }

  private resolveDeviceType(name: string): DeviceType {
    const nameLowercase = name.toLowerCase();
    if (nameLowercase.includes('tablet') || nameLowercase.includes('ipad')) {
      return 'tablet';
    } else if (nameLowercase.includes('android') || nameLowercase.includes('iphone')) {
      return 'phone';
    } else {
      return 'pc';
    }
  }
}
